import { useEffect, useState } from 'react';

export function useMediaRestore() {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const restore = () => setRevision((value) => value + 1);
    window.addEventListener('biblioteca:media-restore', restore);
    return () => window.removeEventListener('biblioteca:media-restore', restore);
  }, []);
  return revision;
}

export function mediaVariantUrl(url, variant, revision = 0) {
  if (!url) return '';
  const [pathname, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('variant', variant);
  if (revision) params.set('restore', String(revision));
  return `${pathname}?${params.toString()}`;
}
